module.exports = {
    bindings: {
        commodityCode: '<',
        foundTexts: '<',
        searchQuery: '<'
    },
    controller: foundTextsController,
    templateUrl: 'search/components/found-texts.html'
};

foundTextsController.$inject = [
    'btiModal', 
    'caseLawModal', 
    'classificationRegulationsModal',
    'customsRulingsModal'
];

function foundTextsController(
    btiModal, 
    caseLawModal, 
    classificationRegulationsModal,
    customsRulingsModal
) {
    var vm = {
        showBti: showBti,
        showCaseLaw: showCaseLaw,
        showClassificationRegulations: showClassificationRegulations,
        showCustomsRulings: showCustomsRulings
    };
    return vm;

    function showBti(code, $event) {
        btiModal.show(code, vm.searchQuery);

        $event.preventDefault();
        $event.stopPropagation();
    }

    function showCustomsRulings(code, $event) {
        customsRulingsModal.show(code, vm.searchQuery);

        $event.preventDefault();
        $event.stopPropagation();
    }

    function showClassificationRegulations(code, $event) {
        classificationRegulationsModal.show(code, vm.searchQuery);

        $event.preventDefault();
        $event.stopPropagation();
    }

    function showCaseLaw(code, $event) {
        caseLawModal.show(code, vm.searchQuery);

        $event.preventDefault();
        $event.stopPropagation();
    }
}